export default "__VITE_ASSET__7hFZmiM9__"